<template lang="pug">
  #app
    router-view
    vue-progress-bar
</template>

<script>
export default {
  name: 'app',
  metaInfo: {
    title: 'AgentBKK',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'robots', content: 'noindex' }
    ],
    link: [
      { rel: 'apple-touch-icon', size: '57x57', href: '/static/favicon/apple-icon-57x57.png' },
      { rel: 'apple-touch-icon', size: '60x60', href: '/static/favicon/apple-icon-60x60.png' },
      { rel: 'apple-touch-icon', size: '72x72', href: '/static/favicon/apple-icon-72x72.png' },
      { rel: 'apple-touch-icon', size: '76x76', href: '/static/favicon/apple-icon-76x76.png' },
      { rel: 'apple-touch-icon', size: '114x114', href: '/static/favicon/apple-icon-114x114.png' },
      { rel: 'apple-touch-icon', size: '120x120', href: '/static/favicon/apple-icon-120x120.png' },
      { rel: 'apple-touch-icon', size: '144x144', href: '/static/favicon/apple-icon-144x144.png' },
      { rel: 'apple-touch-icon', size: '152x152', href: '/static/favicon/apple-icon-152x152.png' },
      { rel: 'apple-touch-icon', size: '180x180', href: '/static/favicon/apple-icon-180x180.png' },
      { rel: 'icon', type: 'image/png', size: '192x192', href: '/static/favicon/android-icon-192x192.png' },
      { rel: 'icon', type: 'image/png', size: '32x32', href: '/static/favicon/android-icon-32x32.png' },
      { rel: 'icon', type: 'image/png', size: '96x96', href: '/static/favicon/android-icon-96x96.png' },
      { rel: 'icon', type: 'image/png', size: '16x16', href: '/static/favicon/android-icon-16x16.png' }
    ]
  },
  created () {
    // [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start()
    // hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      // does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress
        // parse meta tags
        this.$Progress.parseMeta(meta)
      }
      // start the progress bar
      this.$Progress.start()
      // continue to next page
      next()
    })
    // hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach((to, from) => {
      // finish the progress bar
      this.$Progress.finish()
    })
  },
  mounted () {
    // [App.vue specific] When App.vue is finish loading finish the progress bar
    this.$Progress.finish()
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?08b86f6c